<div [formGroup]="campaignForm" class="has-validation">
  <label class="form-label">
    {{ 'field.invoiceEmail' | translate }}
  </label>
  <input type="text" class="form-control" id="billingEmail" formControlName="billingEmail"  [ngClass]="{ 'is-invalid': campaignForm.get('billingEmail')?.invalid}" />
  <input type="checkbox" class="form-check-input" formControlName="billingEmailChecked" (change)="checkboxClicked()" id="billingEmailId"> <label class="form-check-label" for="billingEmailId">{{'campaign.useEmail' | translate}}</label>
  <div [ngClass]="{ 'invalid-feedback': campaignForm.get('billingEmail')?.invalid}" class="form-text">
    <div *ngFor="let err of campaignForm.get('billingEmail')?.errors | keyvalue">
      {{ 'validation.' + err.key | translate }}
    </div>
  </div>
</div>
